import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const NeedHelpLazy = lazyLoader(
  () => import('./NeedHelp' /* webpackChunkName: "need-help" */),
);

const NeedHelp = () => {
  return (
    <Suspense fallback={null}>
      <NeedHelpLazy />
    </Suspense>
  );
};

export default NeedHelp;
